export default function isValidWechatLoginUrl() {
    const url = window.location.href;
    return url.match('h5.siuvo.cn') || url.match('h5-duiyang.siuvo.cn');
}